import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TSetPaymentQrCode = IAction<EPaymentActions.SET_PAYMENT_QR_CODE, string>

const setPaymentQrCode = (qrCode: string): TSetPaymentQrCode => ({
    type: EPaymentActions.SET_PAYMENT_QR_CODE,
    payload: qrCode,
});

export default setPaymentQrCode;
